import * as v from "valibot";

import { rpcContract } from "../rpc";

export const publicUnifiedLinksRpcContract = rpcContract({
  name: "publicUnifiedLinks",
  paramsSchema: v.object({
    handle: v.pipe(v.string(), v.minLength(3), v.maxLength(64)),
    community_id: v.optional(v.string()),
  }),
  resultSchema: v.object({
    links: v.array(
      v.object({
        id: v.string(),
        title: v.string(),
        url: v.string(),
        teaser: v.nullable(v.string()),
        code: v.nullable(v.string()),
        thumbnail: v.nullable(v.string()),
        has_discount: v.boolean(),
        exclusive: v.boolean(),
        waiting_list: v.boolean(),
        priority: v.nullable(v.number()),
        end_date: v.nullable(v.string()),
        contentTier: v.optional(v.union([v.literal("free"), v.literal("premium")])),
        hasAccess: v.boolean(),
        oneTimeProduct: v.optional(
          v.object({
            id: v.string(),
            priceCents: v.number(),
          }),
        ),
        promotion_file: v.nullable(
          v.object({
            id: v.string(),
            path: v.string(),
            thumbnail_path: v.nullable(v.string()),
            mime_type: v.nullable(v.string()),
          }),
        ),
        promotion_brand: v.nullable(
          v.object({
            id: v.string(),
            name: v.string(),
            thumbnail: v.nullable(v.string()),
          }),
        ),
        creator: v.nullable(
          v.object({
            id: v.string(),
            handle: v.nullable(v.string()),
            profile_image: v.nullable(v.string()),
            avatar_file: v.nullable(
              v.object({
                id: v.string(),
                path: v.string(),
                thumbnail_path: v.nullable(v.string()),
              }),
            ),
          }),
        ),
      }),
    ),
  }),
});

export type PublicUnifiedLinksParams = v.InferOutput<(typeof publicUnifiedLinksRpcContract)["paramsSchema"]>;
export type PublicUnifiedLinksResult = v.InferOutput<(typeof publicUnifiedLinksRpcContract)["resultSchema"]>;
export type UnifiedLink = v.InferOutput<(typeof publicUnifiedLinksRpcContract)["resultSchema"]>["links"][number];
